type DeviceType =
  | 'mobileS'
  | 'mobileM'
  | 'mobileL'
  | 'tablet'
  | 'laptopS'
  | 'laptopM'
  | 'laptopL'
  | 'desktopS'
  | 'desktopM'
  | 'desktopL'
  | 'uhd4k'
  | 'dci4k';

export const devices: Record<DeviceType, number> = {
  mobileS: 320,
  mobileM: 375,
  mobileL: 576,
  tablet: 768,
  laptopS: 1024,
  laptopM: 1280,
  laptopL: 1440,
  desktopS: 2560,
  desktopM: 3200,
  desktopL: 3440,
  uhd4k: 3840,
  dci4k: 4096,
};
